// extracted by mini-css-extract-plugin
export default {"root":"styles-root-fc9ff7","sizer":"styles-sizer-e92952"};